<template>
  <user-form
    @save="saveUser()"
    :user="user"
    :roles="roles"
    :saveLoading="saveLoading"
  ></user-form>
</template>

<script>
import { mapGetters } from 'vuex';
import UserForm from '../../components/UserForm.vue';

export default {
  name: 'add-user-view',
  components: { UserForm },
  data() {
    return {
      user: {
        givenName: '',
        familyName: '',
        email: '',
        communicationLanguage: '',
        role: '',
      },
      saveLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      roles: 'users/roles',
    }),
  },
  methods: {
    async saveUser() {
      try {
        this.saveLoading = true;
        const payload = this.user;
        const result = await this.$store.dispatch('users/createUser', payload);

        if (!result.errorCode) {
          await this.$router.push('/users/');
        }
      } finally {
        this.saveLoading = false;
      }
    },
  },
};
</script>
